(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["exceptional-white-truffle-finds"] && !Shopify.designMode) return;
  try {
    
if (!window.tcExceptionalFindsBound) {
  window.tcExceptionalFindsBound = true;
  document.addEventListener('click', function(event) {
    const link = event.target.closest('[data-find-photo]');
    if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    const dialog = link.closest('.tc-finds').querySelector('dialog');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    event.preventDefault();
    const photo = dialog.querySelector('img');
    photo.src = link.href;
    photo.alt = link.querySelector('img').alt;
    dialog.showModal();
    dialog.addEventListener('close', function() { link.focus(); }, {once:true});
  });
  const expire = function() {
    document.querySelectorAll('.tc-find[data-expires]').forEach(function(card) {
      const expiry = Date.parse(card.dataset.expires);
      if (Number.isFinite(expiry) && Date.now() >= expiry) card.remove();
    });
    document.querySelectorAll('.tc-finds').forEach(function(section) {
      const current = section.querySelector('.tc-finds__current');
      const heading = section.querySelector('.tc-finds__current-heading');
      if (heading && current && !current.querySelector('.tc-find')) heading.hidden = true;
      if (!section.querySelector('.tc-find')) section.hidden = true;
    });
  };
  expire();
  setInterval(expire, 60000);
  document.addEventListener('shopify:section:load', expire);
}

  } catch(e) { console.error(e); }
})();
})();
